"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemporaryConnectionRpcLocal = void 0;
const dht_1 = require("@streamr/dht");
const NetworkRpc_client_1 = require("../../../generated/packages/trackerless-network/protos/NetworkRpc.client");
const ContentDeliveryRpcRemote_1 = require("../ContentDeliveryRpcRemote");
const NodeList_1 = require("../NodeList");
const LOCK_ID_BASE = 'system/content-delivery/temporary-connection/';
class TemporaryConnectionRpcLocal {
    options;
    temporaryNodes;
    lockId;
    constructor(options) {
        this.options = options;
        // TODO use options option or named constant?
        this.temporaryNodes = new NodeList_1.NodeList((0, dht_1.toNodeId)(options.localPeerDescriptor), 10);
        this.lockId = LOCK_ID_BASE + options.streamPartId;
    }
    getNodes() {
        return this.temporaryNodes;
    }
    hasNode(node) {
        return this.temporaryNodes.has(node);
    }
    removeNode(nodeId) {
        this.temporaryNodes.remove(nodeId);
        this.options.connectionLocker.weakUnlockConnection(nodeId, this.lockId);
    }
    async openConnection(_request, context) {
        const sender = context.incomingSourceDescriptor;
        const remote = new ContentDeliveryRpcRemote_1.ContentDeliveryRpcRemote(this.options.localPeerDescriptor, sender, this.options.rpcCommunicator, NetworkRpc_client_1.ContentDeliveryRpcClient);
        this.temporaryNodes.add(remote);
        this.options.connectionLocker.weakLockConnection((0, dht_1.toNodeId)(sender), this.lockId);
        return {
            accepted: true
        };
    }
    async closeConnection(_request, context) {
        const remoteNodeId = (0, dht_1.toNodeId)(context.incomingSourceDescriptor);
        this.removeNode(remoteNodeId);
        return {};
    }
}
exports.TemporaryConnectionRpcLocal = TemporaryConnectionRpcLocal;
//# sourceMappingURL=TemporaryConnectionRpcLocal.js.map